import Form from "./FormApi";
import DoneForm from "./DoneFormApi";
import User from "./UserApi";
import Solution from "./SolutionApi";
import Dashboard from "./DashboardApi";
import Department from "./DepartmentApi";
import Role from "./RoleApi";
import Proposal from "./ProposalApi";
import ActionPlan from "./ActionPlanApi";

import Company from "./CompanyApi";

import CustomField from "./CustomFieldApi";
import CustomValue from "./CustomValueApi";

import Notific from "./NotificApi";

import ItemSetup from "./ItemSetupApi";
import DoneItem from "./DoneItemApi";

import Comment from "./CommentApi";

import Task from "./TaskApi";
import Schedule from "./ScheduleApi";

import ExtraInfo from "./ExtraInfoApi";
import Laudo from "./LaudoApi";

import ApiKey from "./ApiKeyApi";
import QrCode from "./QrCodeApi";

import GhostExecution from "./GhostExecutionApi"
import GhostExecutionItem from "./GhostExecutionItemApi"

import Flow from '../_flow/FlowApi'
import DoneFlow from '../_flow/DoneFlowApi'
import DoneApproval from '../_flow/DoneApprovalApi'
import ItemSetupStep from "./ItemSetupStepApi";

import Approval from "./ApprovalApi";
import ReprovedDoneItem from "./ReprovedDoneItemApi";

import Employee from "./EmployeeApi";

import InputMask from "./InputMaskApi";

import DataExport from "./DataExportApi";
import DataImport from "./DataImportApi";
import DefaultImportFile from "./DefaultImportFileApi";

import Ai from './ai/ai_index'
import CheckImageByAi from "./CheckImageByAi";
import AiExtract from "./AiRequestSessionApi";

export default {
  DoneForm,
  Dashboard,
  Solution,
  Form,
  User,
  Department,
  Proposal,
  ActionPlan,
  Company,

  CustomField,
  CustomValue,
  
  ItemSetup,
  DoneItem,

  Comment,
  
  Role,

  Notific,

  Task,
  Schedule,
  
  ExtraInfo,
  Laudo,

  ApiKey,

  QrCode,
  GhostExecution,
  GhostExecutionItem,

  Flow,
  DoneApproval,
  ItemSetupStep,

  Approval,
  ReprovedDoneItem,

  DoneFlow,

  Employee,

  InputMask,

  DataExport,
  DataImport,
  DefaultImportFile,

  Ai,
  CheckImageByAi,
  AiExtract,
};
